export const socialStudio = {
  menu: { label: "Social Studio" },
  pageTitle: "Social Studio",
  subtitle: "Tervezd, ütemezd és menedzseld Instagram posztjaid és sztorijaid egy helyen.",
  cta: {
    newPost: "Új poszt",
    newStory: "Új story",
    publishNow: "Publikálás most",
    schedule: "Ütemezés",
    saveDraft: "Mentés vázlatként",
    save: "Mentés",
    cancel: "Mégse",
    back: "Vissza",
    delete: "Törlés",
    edit: "Szerkesztés",
    duplicate: "Duplikálás",
    aiRewrite: "AI újraírás",
    suggestTime: "Optimális idő",
    accept: "Elfogadás",
    discard: "Elvetés",
    apply: "Alkalmazás",
    addToSeries: "Sorozathoz adás",
    askAi: "Kérdezd az AI-t",
  },
  tabs: {
    feed: "Feed",
    stories: "Stories",
    calendar: "Naptár",
    drafts: "Vázlatok",
    inspiration: "Ötletek",
  },
  status: {
    published: "Publikálva",
    scheduled: "Ütemezve",
    draft: "Vázlat",
  },
  stats: {
    scheduled: "Ütemezve",
    activeStories: "Aktív sztorik",
    weeklyReach: "Heti elérés",
    engagement: "Engagement",
    nextPublish: "Következő poszt",
    posted: "Publikálva ezen a héten",
  },
  feed: {
    title: "Feed áttekintés",
    sectionPast: "Korábbi posztok",
    sectionScheduled: "Beütemezett posztok",
    sectionDrafts: "Vázlatok",
    empty: "Még nincs ilyen tartalom.",
    likes: "kedvelés",
    comments: "komment",
    saves: "mentés",
    reach: "elérés",
  },
  stories: {
    title: "Stories",
    series: "Sorozat",
    addToSeries: "Sorozathoz adás",
    seriesEmpty: "Még nincs aktív story sorozat.",
    duration: "Időtartam",
    seconds: "mp",
  },
  calendar: {
    title: "Tartalmi naptár",
    monthly: "Havi",
    weekly: "Heti",
    list: "Lista",
    today: "Ma",
    dragHint: "Húzd át a kártyát másik napra az átütemezéshez",
    filters: {
      all: "Mind",
      posts: "Posztok",
      stories: "Stories",
      drafts: "Vázlatok",
    },
    drawerTitle: "Aznapi tartalmak",
    noContent: "Nincs ütemezett tartalom erre a napra.",
  },
  editor: {
    postTitle: "Poszt szerkesztő",
    storyTitle: "Story szerkesztő",
    sections: {
      media: "Médiák",
      caption: "Caption",
      hashtags: "Hashtagek",
      location: "Helyszín",
      tagging: "Címkézés",
      schedule: "Ütemezés",
      crossPost: "Megosztás más platformra",
      pillar: "Tartalmi pillér",
    },
    media: {
      addFromLibrary: "Hozzáadás könyvtárból",
      upload: "Feltöltés",
      generateAi: "AI generálás",
      reorderHint: "Húzd a sorrend változtatáshoz",
      ratio: "Képarány",
    },
    caption: {
      placeholder: "Írd ide a caption-t...",
      counter: "{{count}}/2200 karakter",
      aiButton: "AI captiont generál",
      aiPromptPlaceholder: "Pl. reggeli rutin a stúdióban",
      tone: "Hangnem",
      tones: { informal: "Informális", professional: "Profi", playful: "Játékos", inspirational: "Inspiráló" },
    },
    hashtags: {
      placeholder: "Hashtag hozzáadása...",
      suggest: "AI javaslat",
      groups: "Mentett csoportok",
      saturation: "Telítettség",
    },
    location: { placeholder: "Helyszín keresése..." },
    tagging: { placeholder: "@felhasználónév" },
    schedule: {
      now: "Publikálás most",
      later: "Ütemezés későbbre",
      draft: "Mentés vázlatként",
      pickDate: "Válassz dátumot",
      pickTime: "Időpont",
      bestTime: "Optimális időpont",
      bestTimeHint: "AI javaslat a követői aktivitás alapján",
    },
    crossPost: { hint: "A poszt automatikusan megjelenik a kiválasztott platformokon" },
    pillar: { placeholder: "Válassz tartalmi pillért..." },
  },
  story: {
    canvas: { hint: "Kattints az elemre a szerkesztéshez, húzd a vászonra a mozgatáshoz" },
    addSticker: "Sticker hozzáadása",
    stickers: {
      text: "Szöveg",
      poll: "Szavazás",
      question: "Kérdés",
      slider: "Csúszka",
      location: "Hely",
      mention: "Mention",
      link: "Link",
      cta: "CTA gomb",
      countdown: "Visszaszámláló",
    },
    background: { change: "Háttér csere", upload: "Saját kép feltöltés" },
    series: { title: "Story sorozat", addNew: "+ Új story a sorozathoz" },
  },
  ai: {
    drawerTitle: "AI Szerkesztő",
    subtitle: "Segítek tartalmaidat finomítani egyetlen kattintással.",
    actions: {
      moreCasual: "Tedd informálisabbá",
      shorter: "Rövidítsd le",
      addEmoji: "Adj emojikat",
      addHashtags: "Javasolj hashtageket",
      translateEn: "Fordítsd angolra",
      abVariant: "Generálj A/B variánst",
      makePunchy: "Tedd erőteljesebbé",
      addCta: "Adj CTA-t a végére",
    },
    chatPlaceholder: "Írd le, mit szeretnél változtatni...",
    generating: "Generálok...",
    diff: { original: "Eredeti", suggestion: "Javaslat" },
    imageGen: {
      title: "AI képgenerálás",
      promptPlaceholder: "Írj le egy képet...",
      generate: "Variációk generálása",
      generating: "Generálás folyamatban...",
    },
  },
  bestTime: {
    title: "Optimális posztolási idők",
    subtitle: "Követőid aktivitása az elmúlt 30 napból",
    legend: { low: "Alacsony", high: "Magas" },
    days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
  },
  pillars: {
    title: "Tartalmi pillérek",
    subtitle: "Tartalmaid eloszlása a témáid között",
    target: "Cél",
    actual: "Tényleges",
    overweight: "Túl sok",
    balanced: "Egyensúlyban",
  },
  hashtags: {
    title: "Hashtag csoportok",
    add: "Új csoport",
    insert: "Beillesztés",
  },
  templates: {
    title: "Sablonok",
    subtitle: "Kezdj innen — egy klikk és tölthető a poszt",
    use: "Használom",
    categories: {
      all: "Összes",
      inspiration: "Inspiráció",
      sales: "Értékesítés",
      lifestyle: "Lifestyle",
      education: "Edukáció",
      community: "Közösség",
    },
  },
  inspiration: {
    title: "Ötletek és trendek",
    subtitle: "AI által javasolt témák a personádhoz",
    sections: {
      trending: "Trendi témák most",
      forYou: "Neked ajánlott",
      reuse: "Régi sikeres posztok újrahasznosítása",
    },
    use: "Készítsünk posztot",
  },
  toasts: {
    saved: "Sikeresen mentve",
    scheduled: "Ütemezve",
    published: "Publikálva",
    deleted: "Törölve",
    aiApplied: "AI javaslat alkalmazva",
    rescheduled: "Átütemezve",
    error: "Hiba történt",
  },
  approval: {
    title: "Jóváhagyási folyamat",
    pending: "Jóváhagyásra vár",
    approve: "Jóváhagyás",
    reject: "Elutasítás",
    notes: "Megjegyzés",
  },
  abTest: {
    title: "A/B variáns",
    variantA: "A variáns",
    variantB: "B variáns",
    predicted: "Becsült engagement",
    pickWinner: "Választás",
  },
  versions: {
    title: "Verzió történet",
    restore: "Visszaállítás",
    minutesAgo: "{{n}} perce",
    hoursAgo: "{{n}} órája",
    daysAgo: "{{n}} napja",
  },
  engagement: {
    title: "Engagement copilot",
    subtitle: "AI által javasolt válaszok a posztod kommentjeire",
    suggested: "AI javaslat",
    reply: "Válasz",
    aiTone: "Hangnemed alapján",
  },
  utm: {
    title: "UTM és link rövidítő",
    short: "Rövidített link",
    clicks: "kattintás",
  },
};
